import { STRAPI_URL } from '@pickles/shared/config/env';

export const getBrandPoster = async () => {
  const res = await fetch(`${STRAPI_URL}/api/brand-poster?populate=*`);
  const data = await res.json();
  return data;
};
